// import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";

export interface LoginReportResponse {
  current_page: number;
  data: Data[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: Link[];
  next_page_url: string;
  path: string;
  per_page: number;
  prev_page_url: any;
  to: number;
  total: number;
}

export interface Data {
  ip: string;
  username?: string;
  activity: string;
  success: boolean;
  status: string;
  user: User;
  attempted_at: string;
}

export interface User {
  id: number;
  nama: string;
}

export interface Link {
  url?: string;
  label: string;
  active: boolean;
}

async function getSkriningBatuk(tglSt: string, tglEnd: string, unitId: string) {
  // const response = await http
  //   .getDataParam(`/laporan/skrining-batuk`, {
  //     params: {
  //       tgl_start: tglSt,
  //       tgl_end: tglEnd,
  //       unit_id: unitId,
  //       format: "excel"
  //     }
  //   })
  //   .catch(err => {
  //     ErrorAlert.showErrorAlert(err);

  //     return Promise.reject(err);
  //   });

  // return response.data;

  const routeData =
    http.getAPI() +
    `/laporan/skrining-batuk?tgl_start=${tglSt}&tgl_end=${tglEnd}&unit_id=${unitId}&format=excel`;

  window.open(routeData);
}

async function getLoginReport(params: any): Promise<LoginReportResponse> {
  const response = await http
    .getDataParam(`/report/login`, {
      params: params
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getAuditTrailReport(params: any): Promise<any> {
  const response = await http
    .getDataParam(`/report/audit-trail`, {
      params: params
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  getSkriningBatuk,
  getLoginReport,
  getAuditTrailReport
};
